import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  TextField,
  ListItemText,
  MenuItem,
  Autocomplete,
  InputAdornment,
  Link,
  IconButton,
  Checkbox,
  FormLabel,
  Popper,
} from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
import { API, graphqlOperation } from 'aws-amplify';
import { getCompanyCodeTranslation } from '../../../graphql';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import PercentIcon from '@mui/icons-material/Percent';
import { MoneyFormat, MoneyFormatv2, MoneyFormatv3, NewMoneyFormatv2 } from '../../../library/MoneyFormat';
import MoneyInput from '../../../components/formElements/moneyFormatInput';
import { useSelector } from 'react-redux';
import { AddBox } from '@mui/icons-material';
import { grey } from '@mui/material/colors';
import AddTdsTcsOptions from '../Modals/TcsTdsOptions/AddTdsTcsOptions';
import { useLocation } from 'react-router-dom';
import ViewTransactionDetails from './ViewTransactionDetails';
import { useGetCompanyCodeTranslationQuery } from '../../../redux/apis/getCompanyCodeTranslation.api';
import { useStateList } from './HandleInvoiceStateProvider';
import { showWarningSnackbar } from '../../../components/snackBar/snakbar';
import { MoneyTextField } from '../../../components';
const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'left',
  fontSize: '14px',
  fontWeight: 'bold',
  boxShadow: 'none',
  color: theme.palette.text.secondary,
}));
const useStyles = makeStyles({
  table: {
    '& .MuiTableCell-root': {
      border: 'none !important',
    },
  },
});

function TotalAmountLabels({ labelNamesOfTcs, labelNamesOfTds, Type }) {
  const {
    setInitialState,
    data,
    setData,
    eImp,
    setEImp,
    invoiceEntry,
    eWayImp,
    setTcsoptionValue,
    setEwayImp,
    setTdsoptionValue,
    totTaxAmt,
    totNetAmt,
    viewMode,
    netAmountToPay,
    setNetAmountToPay,
    amountAfterDiscount,
    setAmountAfterDiscount,
    amountAfterTCS,
    setAmountAfterTCS,
    amountAfterTDS,
    setAmountAfterTDS,

    tcsSections,
    setTcsSections,
    tdsSections,
    setTdsSections,
    items,
    nonItems,
    partyAccountID,
    setLinkedTransArr,
    partyType,
  } = useStateList();
  const discountType = [
    { option: '%', value: '1' },
    { option: data?.currency?.sign, value: '2' },
  ];

  const classes = useStyles();
  console.log(data, 'dataaaa');
  console.log(items, 'items');
  // console.log(items,"items");
  const [currentLinkedAmt, setCurrentLinkedAmt] = useState(0);
  const [openTdsTcsModal, setOpenTdsTcsModal] = useState(false);
  const [optionType, setOptionType] = useState('');
  const [openTransaction, setOpenTransaction] = useState(false);
  let location = useLocation();
  let getCompany = useSelector((state) => state?.companyReducer?.companyDetails);
  const {
    data: tcsList,
    isLoading: isTcsListLoading,
    isError: isTcsListError,
    // refetch
  } = useGetCompanyCodeTranslationQuery({
    codetype: labelNamesOfTcs?.tdsOrTcsType,
  });

  const {
    data: tdsList,
    isLoading: isTdsListLoading,
    isError: isTdsListError,
    // refetch
  } = useGetCompanyCodeTranslationQuery({
    codetype: labelNamesOfTds?.tdsOrTcsType,
  });

  const { einvoiceflag, ewaybillflag, registrationtype } = getCompany?.relatedcompanydetailsnew?.[0];
  console.log(ewaybillflag, einvoiceflag, 'einvoiceflag');
  console.log(getCompany, 'getCompany');

  const handleAdjustmentTypeChange = (e) => {
    const value = e.target.value;
    setData((prev) => ({
      ...prev,
      adjustmentsType: value,
      adjustmentsValue: 0,
      adjustments: 0,
    }));
  };

  const handleAdjustmentTypeKeyDown = (e) => {
    if (e.key === 'Tab' && e.shiftKey) {
      e.preventDefault();
      e.stopPropagation();
      const updatedTableArr = [...items];
      const zeroItemIndex =
        updatedTableArr.findIndex((row) => row.itemCode.value === '') !== -1
          ? updatedTableArr.findIndex((row) => row.itemCode.value === '')
          : updatedTableArr.findIndex((row) => row.itemCode.value !== '');
      const updatedNonTableArr = [...nonItems];
      const zeroNonItemIndex =
        updatedNonTableArr.findIndex((row) => row.ledgerAccount.value === '') !== -1
          ? updatedNonTableArr.findIndex((row) => row.ledgerAccount.value === '')
          : updatedNonTableArr.findIndex((row) => row.ledgerAccount.value !== '');

      let element = Type === 'Pos' ? 'itemCode' + zeroItemIndex : 'ledgerAccount' + zeroNonItemIndex;
      element = document.getElementById(element);
      element.focus();
    }
  };
  const handleAdjustmentsChange = (val) => {
    // let value = e.target.value;
    // value = value.replace(/,/g, '');
    // if (!/^\d*(?:\.\d*)?$/.test(value)) {
    //   return;
    // }
    // if (value.includes('.') && value.split('.')[1].length > 2) {
    //   return;
    // }
    // let value = e.target.value.replace(/,/g, ''); // Remove commas
    
    let value=Number(val);
     if (!/^-?\d*(?:\.\d*)?$/.test(value) || !/^-?\d*\.?\d{0,2}$/.test(value)) {
      return;
    }
    if (value > 99.99) {
      showWarningSnackbar('The entered discount percentage must not exceed 99.99%. Please correct the value.');
      return;
    }

    if (value === '') {
      setData((prev) => ({
        ...prev,
        adjustmentsValue: 0,
        adjustments: 0,
        errorStatus: {
          ...prev.errorStatus,
          adjustmentsValue: false,
        },
        errorFields: {
          ...prev.errorFields,
          adjustments: '',
        },
      }));
    } else {
      let adjAmt = (totTaxAmt * value) / 100;
      adjAmt = Math.floor(Number(adjAmt) * 100) / 100;
      setData((prev) => ({
        ...prev,
        adjustmentsValue: value,
        adjustments: data.adjustmentsType == '1' ? adjAmt : value,
        errorStatus: {
          ...prev.errorStatus,
          adjustmentsValue: false,
          adjustments: false,
          receivedAmount: false,
        },
        errorFields: {
          ...prev.errorFields,
          adjustmentsValue: '',
          receivedAmount: '',
          adjustments: '',
        },
      }));
    }
  };

  const handleAdjustmentsBlur = () => {
    setData((prev) => {
      let formattedValue = prev.adjustmentsValue;
      if (formattedValue === '.') {
        formattedValue = '0.00';
      }

      if (!/^-?\d*(\.\d{0,2})?$/.test(formattedValue)) {
        formattedValue = '0';
      }

      if (!isNaN(parseFloat(formattedValue))) {
        formattedValue = parseFloat(formattedValue).toFixed(2);
      }

      return {
        ...prev,
        adjustmentsValue: Number(formattedValue),
      };
    });
  };
  const handleMoneyInputChange = (val) => {
  //  let value = e.target.value.replace(/,/g, '');
  let value=Number(val);
    if (!/^-?\d*(?:\.\d*)?$/.test(value) || !/^-?\d*\.?\d{0,2}$/.test(value)) {
      return;
    }
    if (value > Number(totTaxAmt)) {
      showWarningSnackbar('The entered discount amount must not exceed the total taxable amount. Please correct the value.');
      return;
    }

    if (value==='') {
      setData((prev) => ({
        ...prev,
        adjustmentsValue: 0,
        adjustments: 0,
        errorStatus: {
          ...prev.errorStatus,
          adjustmentsValue: false,
        },
        errorFields: {
          ...prev.errorFields,
          adjustments: '',
        },
      }));
    } else {
      let adjAmt = (totTaxAmt * value) / 100;
      adjAmt = Math.floor(Number(adjAmt) * 100) / 100;
      setData((prev) => ({
        ...prev,
        adjustmentsValue: value,
        adjustments: data.adjustmentsType == '1' ? adjAmt : value,
        errorStatus: {
          ...prev.errorStatus,
          adjustmentsValue: false,
          adjustments: false,
          receivedAmount: false,
        },
        errorFields: {
          ...prev.errorFields,
          adjustmentsValue: '',
          receivedAmount: '',
          adjustments: '',
        },
      }));
    }
  };
  const handleTdsOptionChange = (event, newValue) => {
    const item = newValue || {
      section: '',
      option: '',
    };
    setTdsoptionValue(item.section);
    let tdsAmount = 0;

    if (totTaxAmt > 0) {
      tdsAmount = (Number(totTaxAmt) * Number(item.value)) / 100;
      tdsAmount = Math.floor(Number(tdsAmount) * 100) / 100;
    }

    setData((prev) => ({
      ...prev,
      tdsPercent: item.section ? item.value : 0,
      tdsOptions: item.section,
      manualTDSAmt: 0,
      manualTdsFlag: 0,
      tdsAmount: item.section ? tdsAmount.toFixed(2) : 0,
      errorStatus: {
        ...prev.errorStatus,
        tdsOptions: false,
        tdsPercent: false,
      },
      errorFields: {
        ...prev.errorFields,
        tdsOptions: '',
        tdsPercent: '',
      },
    }));
  };

  const handleAddNewTdsOption = (event) => {
    event.stopPropagation();
    event.preventDefault();
    setOptionType('Add New TDS Option');
    setOpenTdsTcsModal(true);
  };
  const handleTdsPercentChange = (val) => {
    // let value = e.target.value;
    let tdsAmount = 0;
    // value = value?.replace(/,/g, '');
    let value=Number(val);

    if (!/^-?\d*(?:\.\d*)?$/.test(value) || !/^-?\d*\.?\d{0,2}$/.test(value)) {
      return;
    }
    if (value > 99.99) {
      showWarningSnackbar('The entered TDS percentage must not exceed 100%. Please correct the value.');
      return;
    }
    const numericValue = parseFloat(value);
    const maxLimit = Number(totNetAmt);

    if (numericValue > maxLimit) {
      return;
    }

    if (value === '') {
      setData((prev) => ({
        ...prev,
        tdsPercent: value,
        tdsAmount: Number(data.manualTDSAmt) !== 0 ? Number(data.manualTDSAmt) : 0,
        errorStatus: {
          ...prev.errorStatus,
          tdsPercent: false,
        },
        errorFields: {
          ...prev.errorFields,
          tdsPercent: '',
        },
      }));
    } else {
      if (totTaxAmt > 0) {
        tdsAmount = (Number(totTaxAmt) * Number(value)) / 100;
        tdsAmount = Math.floor(Number(tdsAmount) * 100) / 100;
      }
      setData((prev) => ({
        ...prev,
        tdsAmount: tdsAmount,
        manualTDSAmt: 0,
        tdsPercent: value,
        manualTdsFlag: 0,
        errorStatus: {
          ...prev.errorStatus,
          tdsPercent: false,
          tdsAmount: false,
        },
        errorFields: {
          ...prev.errorFields,
          tdsPercent: '',
          tdsAmount: '',
        },
      }));
    }
  };

  const handleTdsPercentBlur = () => {
    setData((prev) => {
      let formattedValue = prev.tdsPercent;
      if (formattedValue === '.') {
        formattedValue = '0.00';
      }

      if (!/^-?\d*(\.\d{0,2})?$/.test(formattedValue)) {
        formattedValue = '0';
      }

      if (!isNaN(parseFloat(formattedValue))) {
        formattedValue = parseFloat(formattedValue).toFixed(2);
      }

      return {
        ...prev,
        tdsPercent: formattedValue,
      };
    });
  };
  const handleTdsAmountChange = (val) => {
    // let value = e.target?.value?.replace(/,/g, '');
    let value=Number(val);
    if (!/^-?\d*(?:\.\d*)?$/.test(value) || !/^-?\d*\.?\d{0,2}$/.test(value)) {
      return;
    }
    const numericValue = parseFloat(value);
    const maxLimit = Number(totTaxAmt - 1);

    if (numericValue > maxLimit) {
      showWarningSnackbar('The entered TDS amount must not exceed the total Taxable Amount. Please correct the value.');
      return;
    }

    setData((prev) => ({
      ...prev,
      tdsAmount: value,
      manualTDSAmt: value,
      manualTdsFlag: value <= 0 ? 0 : 1,
      errorStatus: {
        ...prev.errorStatus,
        tdsAmount: false,
      },
      errorFields: {
        ...prev.errorFields,
        tdsAmount: '',
      },
    }));
  };

  const handleTdsAmountBlur = () => {
    setData((prev) => {
      let formattedValue = prev.tdsAmount;
      if (formattedValue === '.') {
        formattedValue = '0.00';
      }
      if (!/^-?\d*(\.\d{0,2})?$/.test(formattedValue)) {
        formattedValue = '0';
      }
      if (!isNaN(parseFloat(formattedValue))) {
        formattedValue = parseFloat(formattedValue).toFixed(2);
      }
      return {
        ...prev,
        tdsAmount: formattedValue,
      };
    });
  };
  const handleTcsOptionChange = (event, newValue) => {
    const item = newValue || { section: '', option: '' };
    setTcsoptionValue(item.section);
    let tcsAmount = 0;

    if (totTaxAmt > 0) {
      tcsAmount = (Number(totTaxAmt) * Number(item.value)) / 100;
      tcsAmount = Math.floor(Number(tcsAmount) * 100) / 100;
    }

    setData((prev) => ({
      ...prev,
      tcsPercent: item.section ? item.value : 0,
      tcsOptions: item.section,
      manualTCSAmt: 0,
      tcsAmount: item.section ? tcsAmount.toFixed(2) : 0,
      manualTcsFlag: 0,
      errorStatus: {
        ...prev.errorStatus,
        tcsOptions: false,
      },
      errorFields: {
        ...prev.errorFields,
        tcsOptions: '',
      },
    }));
  };

  const handleAddNewTcsOptionClick = (event) => {
    event.stopPropagation();
    event.preventDefault();
    setOptionType('Add New TCS Option');
    setOpenTdsTcsModal(true);
  };
  const handleTcsPercentChange = (val) => {
    // let value = e.target.value;
    let value=Number(val);
    let tcsAmount = 0;
    // value = value?.replace(/,/g, '');
    

   if (!/^-?\d*(?:\.\d*)?$/.test(value) || !/^-?\d*\.?\d{0,2}$/.test(value)) {
      return;
    }
    if (value > 100) {
      showWarningSnackbar('The entered TCS percentage must not exceed 100%. Please correct the value.');
      return;
    }

    if (value === '') {
      setData((prev) => ({
        ...prev,
        tcsPercent: value,
        tcsAmount: Number(data.manualTCSAmt) !== 0 ? Number(data.manualTCSAmt) : 0,
        errorStatus: { ...prev.errorStatus, tcsPercent: false },
        errorFields: { ...prev.errorFields, tcsPercent: '' },
      }));
    } else {
      if (totTaxAmt > 0) {
        tcsAmount = (Number(totTaxAmt) * Number(value)) / 100;
        tcsAmount = Math.floor(Number(tcsAmount) * 100) / 100;
      }
      setData((prev) => ({
        ...prev,
        tcsAmount,
        tcsPercent: value,
        manualTCSAmt: 0,
        manualTcsFlag: 0,
        errorStatus: {
          ...prev.errorStatus,
          tcsPercent: false,
          tcsAmount: false,
        },
        errorFields: { ...prev.errorFields, tcsPercent: '', tcsAmount: '' },
      }));
    }
  };

  const handleTcsPercentBlur = () => {
    setData((prev) => {
      let formattedValue = prev.tcsPercent;
      if (formattedValue === '.') formattedValue = '0.00';
      if (!/^-?\d*(\.\d{0,2})?$/.test(formattedValue)) formattedValue = '0';
      if (!isNaN(parseFloat(formattedValue))) {
        formattedValue = parseFloat(formattedValue).toFixed(2);
      }
      return { ...prev, tcsPercent: formattedValue };
    });
  };

  const handleTcsAmountChange = (val) => {
    // let value = e?.target?.value;
    // value = value.replace(/,/g, '');
    let value=Number(val);
   if (!/^-?\d*(?:\.\d*)?$/.test(value) || !/^-?\d*\.?\d{0,2}$/.test(value)) {
      return;
    }
    const numericValue = parseFloat(value);
    const maxLimit = Number(totTaxAmt);

    if (numericValue > maxLimit) {
      showWarningSnackbar('The entered TCS amount must not exceed the total Taxable Amount. Please correct the value.');
      return;
    }

    setData((prev) => ({
      ...prev,
      tcsAmount: value,
      manualTCSAmt: value,
      manualTcsFlag: value > 0 ? 1 : 0,
      errorStatus: {
        ...prev.errorStatus,
        tcsAmount: false,
      },
      errorFields: {
        ...prev.errorFields,
        tcsAmount: '',
      },
    }));
  };

  const handleTcsAmountBlur = () => {
    setData((prev) => {
      let formattedValue = prev.tcsAmount;
      if (formattedValue === '.') {
        formattedValue = '0.00';
      }

      if (!/^-?\d*(\.\d{0,2})?$/.test(formattedValue)) {
        formattedValue = '0';
      }

      if (!isNaN(parseFloat(formattedValue))) {
        formattedValue = parseFloat(formattedValue).toFixed(2);
      }

      return {
        ...prev,
        tcsAmount: formattedValue,
      };
    });
  };
  const handleRoundOffChange = (val) => {
    // let value = e.target.value;
    //  value = value.replace(/,/g, '');
    let value=Number(val);

     if (!/^-?\d*(?:\.\d*)?$/.test(value) || !/^-?\d*\.?\d{0,2}$/.test(value)) {
      return;
    }

    const numericValue = parseFloat(value);
    const maxLimit = 99.99;
    const minLimit = -99.99;

    if (!isNaN(numericValue)) {
      if (numericValue > maxLimit) {
        showWarningSnackbar('Round-off amount exceeds the maximum limit');
        return;
      }
      if (numericValue < minLimit) {
        showWarningSnackbar('Round-off amount is below the minimum limit');
        return;
      }
    }

    setData((prev) => ({
      ...prev,
      roundOff: value,
    }));
  };

  const handleRoundOffBlur = () => {
    setData((prev) => {
      let formattedValue = prev.roundOff;
      if (formattedValue === '.') {
        formattedValue = '0.00';
      }

      if (!/^-?\d*(\.\d{0,2})?$/.test(formattedValue)) {
        formattedValue = '0';
      }

      if (!isNaN(parseFloat(formattedValue))) {
        formattedValue = parseFloat(formattedValue).toFixed(2);
      }

      return {
        ...prev,
        roundOff: isNaN(Number(formattedValue)) ? 0 : Number(formattedValue),
      };
    });
  };
  async function getTcsSection() {
    if (!tcsList) {
      setTcsSections([]);
    } else {
      let sectionArrays = tcsList?.map((element) => {
        return {
          option: `${element.codetext} (${element.codevalue}%)`,
          value: `${element.codevalue}`,
          section: element.codeorder,
        };
      });
      setTcsSections(sectionArrays);
    }
  }
  async function getTdsSection() {
    if (!tdsList) {
      setTdsSections([]);
    } else {
      let sectionArrays = tdsList?.map((element) => {
        return {
          option: `${element.codetext} (${element.codevalue}%)`,
          value: `${element.codevalue}`,
          section: element.codeorder,
        };
      });

      setTdsSections(sectionArrays);
    }
  }
  async function getTotalAmountToPay() {
    let amountAfterDiscount = 0;
    amountAfterDiscount = Number(totNetAmt) - Number(data.adjustments);

    setAmountAfterDiscount(amountAfterDiscount);
    let amountAfterTCSOrTDS = 0;
    let amountAfterTDS = 0;
    if (Type === 'Sales' || Type === 'DebitNote' || Type === 'CreditNote' || Type === 'Pos') {
      amountAfterTCSOrTDS = Number(Number(amountAfterDiscount) + Number(data.tcsAmount)).toFixed(2);
      setAmountAfterTCS(amountAfterTCSOrTDS);
    }
    if (Type === 'Purchase' || ((Type === 'CreditNote' || Type === 'DebitNote') && partyType === 'SUPPLIER')) {
      amountAfterTCSOrTDS = Number(Number(amountAfterDiscount) - Number(data.tdsAmount) + Number(data.tcsAmount)).toFixed(2);
      amountAfterTDS = Number(Number(amountAfterDiscount) - Number(data.tdsAmount)).toFixed(2);
      setAmountAfterTDS(amountAfterTDS);
      setAmountAfterTCS(amountAfterTCSOrTDS);
    }
    if (Type === 'Sales' || Type === 'DebitNote' || Type === 'CreditNote' || Type === 'Pos') {
      let netAmountToPay = Number(amountAfterDiscount + Number(data.tcsAmount) + (isNaN(data.roundOff) ? 0 : Number(data.roundOff)));
      netAmountToPay = Math.round(netAmountToPay * 100) / 100;

      setNetAmountToPay(netAmountToPay);
    }
    if (Type === 'Purchase' || ((Type === 'CreditNote' || Type === 'DebitNote') && partyType === 'SUPPLIER')) {
      let netAmountToPay = Number(
        Number(amountAfterDiscount) - Number(data.tdsAmount) + Number(data.tcsAmount) + (isNaN(data.roundOff) ? 0 : Number(data.roundOff))
      );

      netAmountToPay = Math.round(netAmountToPay * 100) / 100;

      setNetAmountToPay(netAmountToPay);
    }
  }
  function getAmountLabels(invoiceEntry) {
    if (invoiceEntry?.length !== 0) {
      let tcsOptions = '';
      let tdsOptions = '';
      let tdsAmount = 0;
      let tcsAmount = 0;
      let tcsPercent = 0;
      let tdsPercent = 0;
      let manualTcsFlag = 0;
      let manualTdsFlag = 0;
      if (Type === 'Sales' || Type === 'Pos') {
        tcsOptions = invoiceEntry?.relatedinvoicetcsdetails?.[0]?.tcssection;
        tcsPercent = invoiceEntry?.relatedinvoicetcsdetails?.[0]?.tcspercentage;
        tcsAmount = invoiceEntry?.relatedinvoicetcsdetails?.[0]?.tcsamount;
        manualTcsFlag = invoiceEntry?.relatedinvoicetcsdetails?.[0]?.tcsmanual;
      }
      if (Type === 'Purchase') {
        tcsOptions = invoiceEntry?.relatedpurchasetcsdetails?.[0]?.tcssection;
        tcsPercent = invoiceEntry?.relatedpurchasetcsdetails?.[0]?.tcspercentage;
        tcsAmount = invoiceEntry?.relatedpurchasetcsdetails?.[0]?.tcsamount;
        tdsOptions = invoiceEntry?.relatedpurchasetdsdetails?.[0]?.tdssection;
        tdsPercent = invoiceEntry?.relatedpurchasetdsdetails?.[0]?.tdspercentage;
        tdsAmount = invoiceEntry?.relatedpurchasetdsdetails?.[0]?.tdsamount;
        manualTcsFlag = invoiceEntry?.relatedpurchasetcsdetails?.[0]?.tcsmanual;
        manualTdsFlag = invoiceEntry?.relatedpurchasetdsdetails?.[0]?.tdsmanual;
      }
      if (Type === 'DebitNote' || Type === 'CreditNote') {
        tcsOptions = invoiceEntry?.relatedcrdrnotetcsdetails?.[0]?.tcssection;
        tcsPercent = invoiceEntry?.relatedcrdrnotetcsdetails?.[0]?.tcspercentage;
        tcsAmount = invoiceEntry?.relatedcrdrnotetcsdetails?.[0]?.tcsamount;
        tdsOptions = invoiceEntry?.relatedcrdrnotetdsdetails?.[0]?.tdssection;
        tdsPercent = invoiceEntry?.relatedcrdrnotetdsdetails?.[0]?.tdspercentage;
        tdsAmount = invoiceEntry?.relatedcrdrnotetdsdetails?.[0]?.tdsamount;
        manualTcsFlag = invoiceEntry?.relatedcrdrnotetcsdetails?.[0]?.tcsmanual;
        manualTdsFlag = invoiceEntry?.relatedcrdrnotetdsdetails?.[0]?.tdsmanual;
      }
      setData((prev) => ({
        ...prev,
        adjustmentsType: invoiceEntry?.discounttype,
        adjustments: invoiceEntry?.adjustmentamount,
        adjustmentsValue: invoiceEntry?.discountvalue,
        roundOff: invoiceEntry?.roundoffamount ? invoiceEntry?.roundoffamount : '',
        tcsOptions: tcsOptions,
        tcsAmount: tcsAmount,
        tcsPercent: tcsPercent,
        tdsOptions: tdsOptions,
        tdsPercent: tdsPercent,
        tdsAmount: tdsAmount,
        manualTDSAmt: manualTdsFlag === 0 ? 0 : tdsAmount,
        manualTCSAmt: manualTcsFlag === 0 ? 0 : tcsAmount,
      }));
      setInitialState((prev) => ({
        ...prev,
        adjustmentsType: invoiceEntry?.discounttype,
        adjustments: invoiceEntry?.adjustmentamount,
        adjustmentsValue: invoiceEntry?.discountvalue,
        roundOff: invoiceEntry?.roundoffamount ? invoiceEntry?.roundoffamount : '',
        tcsOptions: tcsOptions,
        tcsAmount: tcsAmount,
        tcsPercent: tcsPercent,
        tdsOptions: tdsOptions,
        tdsPercent: tdsPercent,
        tdsAmount: tdsAmount,
        manualTDSAmt: manualTdsFlag === 0 ? 0 : tdsAmount,
        manualTCSAmt: manualTcsFlag === 0 ? 0 : tcsAmount,
      }));
    }
  }
  function displayBalanceDue() {
    let balancedue = Number(netAmountToPay) - Number(data.receivedAmount) - Number(currentLinkedAmt);
    setData((prev) => ({
      ...prev,
      balanceDueAmt: balancedue,
    }));
    if (setInitialState) {
      setInitialState((prev) => ({
        ...prev,
        balanceDueAmt: balancedue,
      }));
    }
  }
  useEffect(() => {
    displayBalanceDue();
  }, [data.receivedAmount, netAmountToPay, currentLinkedAmt]);
  useEffect(() => {
    getTotalAmountToPay();
  }, [data.adjustments, data.tcsAmount, data.tdsAmount, totNetAmt, data.roundOff, data.adjustmentsType, data.reverseChargeFlag]);

  useEffect(() => {
    getTcsSection();

    if (partyType === 'SUPPLIER') {
      getTdsSection();
    }
  }, [partyType, tdsList, tcsList]);
  useEffect(() => {
    getAmountLabels(invoiceEntry);
  }, [invoiceEntry]);
  const moveCursorToEnd = (event) => {
    event.target.focus();
    event.target.setSelectionRange(event.target.value.length, event.target.value.length);
  };
  const hasGoods = items.some((item) => item?.itemType === 'GOODS');
  return (
    <Box className={viewMode == true ? 'disable-interactions' : ''}>
      <TableContainer sx={{ maxHeight: 400 }} aria-setsize="small">
        <Table
          className={classes.table}
          sx={{
            '.css-1bl26gx-MuiTableCell-root': {
              lineHeight: '0.1rem',
            },
          }}
          aria-label="simple table"
        >
          <TableBody
            sx={{
              '.MuiTableCell-root': {
                backgroundColor: 'transparent !important',
                padding: '1px 10px',
                fontSize: '13px',
              },
            }}
          >
            <TableRow sx={{ fontWeight: 400, fontSize: '14px', height: '30px' }}>
              <TableCell sx={{ fontWeight: 400, fontSize: '14px', minWidth: '120px' }}>{labelNamesOfTcs?.amountName}</TableCell>
              <TableCell></TableCell>
              <TableCell align="right" sx={{ minWidth: '150px', fontWeight: 400, fontSize: '14px' }}>
                {data?.currency?.sign} {MoneyFormatv3(Number(totNetAmt).toFixed(2), 'en-IN')}
              </TableCell>
            </TableRow>
            <TableRow sx={{ fontWeight: 400, fontSize: '14px', height: '30px' }}>
              <TableCell sx={{ fontWeight: 400, fontSize: '14px', minWidth: '120px' }}>Additional Discount if any</TableCell>
              <TableCell
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  minWidth: '120px',
                  alignItems: 'flex-end',
                  border: 'none !important',
                  outline: 'none !important',
                  boxShadow: 'none !important',

                  // prevent outline or shadow on focus (if TableCell can get focused)
                  '&:focus, &:focus-visible': {
                    outline: 'none !important',
                    boxShadow: 'none !important',
                  },
                }}
              >
                {/* <TextField
                  select
                  value={data.adjustmentsType}
                  size="small"
                  id="adjustmentsType"
                  onChange={handleAdjustmentTypeChange}
                  onKeyDown={handleAdjustmentTypeKeyDown}
                  disabled={
                    data?.partyName?.value === "" || totNetAmt == 0
                      ? true
                      : false
                  }
                  SelectProps={{
                    onClose: handleAdjustmentDropdownClose, // 👈 Add this
                  }}
                  sx={{
                    flex: 1,
                    ".MuiOutlinedInput-root": {
                      height: "35px",
                    },
                  }}
                >
                  {discountType.map((item, ind) => {
                    if (item.value === "2") {
                      item.option = data?.currency?.sign;
                    }
                    return (
                      <MenuItem key={item.value} value={`${item.value}`}>
                        <ListItemText
                          sx={{ margin: "0px" }}
                          primary={item.option}
                        />
                      </MenuItem>
                    );
                  })}
                </TextField> */}
                <Autocomplete
                  value={discountType.find((item) => item.value === String(data?.adjustmentsType)) || null}
                  freeSolo={false}
                  onChange={(event, newValue) => {
                    handleAdjustmentTypeChange({
                      target: { value: newValue ? newValue.value : '' },
                    });
                  }}
                  disableClearable
                  onKeyDown={handleAdjustmentTypeKeyDown}
                  options={discountType.map((item) => {
                    if (item.value === '2') {
                      return { ...item, option: data?.currency?.sign };
                    }
                    return item;
                  })}
                  getOptionLabel={(option) => option.option || ''}
                  isOptionEqualToValue={(option, value) => option.value === value.value}
                  disabled={data?.partyName?.value === '' || totNetAmt === 0}
                  size="small"
                  id="adjustmentsType"
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        ...params.InputProps,
                        inputProps: {
                          ...params.inputProps,
                          readOnly: true, // 👈 this is the correct place
                        },
                      }}
                      sx={{
                        flex: 1,
                        '.MuiOutlinedInput-root': {
                          height: '35px',
                        },
                      }}
                    />
                  )}
                  sx={{
                    flex: 1,
                    '.MuiOutlinedInput-root': {
                      height: '35px',
                    },
                  }}
                />
                {data.adjustmentsType == '1' ? (
                  <MoneyTextField
                    error={data.errorStatus.adjustments == true ? true : false}
                    label="Less Extra Discount"
                    id="adjustments"
                    name="adjustments"
                    size="small"
                    disabled={data?.partyName?.value === '' || totNetAmt == 0 ? true : false}
                    value={data.adjustmentsValue?Number(data.adjustmentsValue):null}
                    onChange={(val)=>handleAdjustmentsChange(val)}
                    // onBlur={handleAdjustmentsBlur}
                    // type="text"
                    min={0}
                    maxErrorMessage={'The entered discount percentage must not exceed 99.99%. Please correct the value.'}
                    max={99.99}
                    fullWidth
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          {data.adjustmentsType == '1' ? <PercentIcon fontSize="14px" /> : data?.currency?.sign}
                        </InputAdornment>
                      ),
                    }}
                    sx={{
                      flex: 1.5,
                      '& .MuiOutlinedInput-input': {
                        outline: 'none',

                        '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
                          WebkitAppearance: 'none',
                          margin: 0,
                        },

                        MozAppearance: 'textfield',
                        textAlign: 'right',
                      },
                    }}
                  />
                ) : (
                  <MoneyTextField
                    error={data.errorStatus.adjustments == true ? true : false}
                    label="Less Extra Discount"
                    id="adjustments"
                    name="adjustments"
                    size="small"
                    state={data}
                    currencyType={data.currency.sign}
                    disabled={data?.partyName?.value === '' || totNetAmt == 0 ? true : false}
                    value={(data.adjustmentsValue)?Number(data?.adjustmentsValue):null}
                    onChange={(val)=>handleMoneyInputChange(val)}
                    min={0}
                    max={Number(totTaxAmt)-1}
                    maxErrorMessage='The entered discount amount must not exceed the total taxable amount. Please correct the value.'
                    type="text"
                    fullWidth
                    
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          {data.adjustmentsType == '1' ? <PercentIcon fontSize="14px" /> : data?.currency?.sign}
                        </InputAdornment>
                      ),
                          inputProps: {
                             style: { textAlign: 'right' }  
                         }

                    }}
                    sx={{
                      flex: 1.5,
                    }}
                  />
                )}
                <Typography
                  sx={{
                    marginTop: '2px',
                    marginLeft: '10px',
                    marginBottom: '0px',
                    fontSize: '11px',
                    color: 'danger.main',
                  }}
                >
                  {data?.errorFields.adjustments}
                </Typography>
              </TableCell>
              <TableCell align="right" sx={{ fontWeight: 400, fontSize: '14px' }}>
                {MoneyFormatv3(Number(data.adjustments).toFixed(2), 'en-IN')}
              </TableCell>
            </TableRow>
            <TableRow sx={{ fontWeight: 400, fontSize: '14px', height: '30px' }}>
              <TableCell sx={{ fontWeight: 400, fontSize: '14px', minWidth: '150px' }}>Amount (After Discount)</TableCell>
              <TableCell></TableCell>
              <TableCell align="right" sx={{ minWidth: '120px', fontWeight: 400, fontSize: '14px' }}>
                {data?.currency?.sign} {MoneyFormatv3(Number(amountAfterDiscount).toFixed(2), 'en-IN')}
              </TableCell>
            </TableRow>
            {(Type == 'Purchase' || partyType === 'SUPPLIER') && (
              <>
                <TableRow sx={{ fontWeight: 400, fontSize: '14px', height: '30px' }}>
                  <TableCell
                    sx={{
                      fontWeight: 400,
                      fontSize: '14px',
                      minWidth: '120px',
                    }}
                  >
                    {labelNamesOfTds?.tcsOrTdsName}
                  </TableCell>
                  <TableCell
                    sx={{
                      display: 'flex',
                      flexDirection: 'row',
                      minWidth: '120px',
                    }}
                  >
                    <Box sx={{ width: '100%', flex: 2 }}>
                      <Autocomplete
                        // disableClearable
                        openOnFocus
                        disabled={data?.partyName?.value === '' || totNetAmt == 0 ? true : false}
                        value={tdsSections?.find((item) => item.section == data.tdsOptions) || null}
                        //  onChange={handleTdsOptionChange}
                        onChange={(event, newValue, reason) => {
                          handleTdsOptionChange(event, newValue);

                          if (reason === 'clear') {
                            handleTdsOptionChange(event, null);
                          }
                        }}
                        options={['Add New TDS Option', ...tdsSections]}
                        getOptionLabel={(option) => option.option}
                        fullWidth
                        PopperComponent={(props) => {
                          const tableCell = props.anchorEl?.closest('td');
                          const totalWidth = tableCell ? tableCell.offsetWidth : 'auto';

                          return (
                            <Popper
                              {...props}
                              style={{
                                ...props.style,
                                width: totalWidth,
                              }}
                              placement="bottom-start"
                            />
                          );
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            name="tdsOptions"
                            label={labelNamesOfTds?.tcsOrTdsLabel}
                            variant="outlined"
                            size="small"
                            InputLabelProps={{
                              shrink: true,
                            }}
                          />
                        )}
                        renderOption={(props, option) => (
                          <>
                            {option === 'Add New TDS Option' ? (
                              <MenuItem
                                value={'addTdsOption'}
                                onClick={handleAddNewTdsOption}
                                sx={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  position: 'sticky',
                                  // bottom: "-7.5px",
                                  top: '0px',
                                  zIndex: 1,
                                  backgroundColor: grey[50],
                                  '&:hover': {
                                    backgroundColor: grey[200],
                                  },
                                }}
                              >
                                <AddBox
                                  fontSize="small"
                                  sx={{
                                    marginRight: '5px',
                                    color: 'primary.main',
                                  }}
                                />
                                <ListItemText sx={{ color: 'primary.main' }} primary="Add New TDS Option" />
                              </MenuItem>
                            ) : (
                              <li {...props}>{option.option}</li>
                            )}
                          </>
                        )}
                      />
                    </Box>
                    <Box sx={{ width: '100%', flex: 2 }}>
                      <MoneyTextField
                        error={data.errorStatus.tdsPercent == true ? true : false}
                        value={(data.tdsPercent)?Number(data?.tdsPercent):null}
                        disabled={data?.partyName?.value === '' || totNetAmt == 0 ? true : false}
                        required={data.tcsFlag === 1 ? true : false}
                        onChange={(val)=>handleTdsPercentChange(val)}
                        // onBlur={handleTdsPercentBlur}
                        id="tdsAmount"
                        label={labelNamesOfTds?.tcsOrTdsAmountLabel}
                        variant="outlined"
                        min={0}
                        max={99.99}
                        size="small"
                        fullWidth
                        sx={{
                          flex: 1,
                          '.css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root': {
                            fontSize: '14px',
                          },
                          label: {
                            fontSize: '14px',
                          },
                          '.css-1atz3nw-MuiFormLabel-root-MuiInputLabel-root': {
                            color: 'input.font',
                          },
                          '.css-1d3z3hw-MuiOutlinedInput-notchedOutline': {
                            borderColor: 'input.border',
                          },
                          '.css-wgai2y-MuiFormLabel-asterisk': {
                            color: 'danger.main',
                          },
                        }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <PercentIcon fontSize="14px" />
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Box>
                  </TableCell>
                  <TableCell
                    align="right"
                    sx={{
                      minWidth: '120px',
                      fontWeight: 400,
                      fontSize: '14px',
                    }}
                  >
                    <MoneyTextField
                      error={data.errorStatus.tdsAmount == true ? true : false}
                      label="TDS Amount"
                      id="tdsAmount"
                      name="tdsAmount"
                      size="small"
                      state={data}
                      currencyType={data.currency.sign}
                      disabled={data?.partyName?.value === '' || totNetAmt == 0 ? true : false}
                      value={(data.tdsAmount)?Number(data?.tdsAmount):null}
                      onChange={(val)=>handleTdsAmountChange(val)}
                      // onBlur={handleTdsAmountBlur}
                      min={0}
                      max={Number(totTaxAmt)-1}
                      maxErrorMessage='The entered TDS amount must not exceed the total Taxable Amount. Please correct the value.'
                      type="text"
                      fullWidth
                     InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            {data?.currency?.sign}
                          </InputAdornment>
                        ),
                            inputProps: {
      style: { textAlign: 'right' }  
    }

                      }}
                      sx={{
                        flex: 1,
                        width: 140,
                        textAlign: 'right',
                      }}
                    />
                  </TableCell>
                </TableRow>
                <TableRow sx={{ fontWeight: 400, fontSize: '14px', height: '30px' }}>
                  <TableCell sx={{ fontWeight: 400, fontSize: '14px' }}>{labelNamesOfTds?.amountAfterLabel}</TableCell>
                  <TableCell></TableCell>
                  <TableCell align="right" sx={{ fontWeight: 400, fontSize: '14px' }}>
                    {data?.currency?.sign} {MoneyFormatv3(Number(amountAfterTDS).toFixed(2), 'en-IN')}
                  </TableCell>
                </TableRow>
              </>
            )}

            <TableRow sx={{ fontWeight: 400, fontSize: '14px', height: '30px' }}>
              <TableCell sx={{ fontWeight: 400, fontSize: '14px', minWidth: '120px' }}>{labelNamesOfTcs?.tcsOrTdsName}</TableCell>
              <TableCell
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  minWidth: '120px',
                }}
              >
                <>
                  <Box sx={{ width: '100%', flex: 3 }}>
                    <Autocomplete
                      openOnFocus
                      // disableClearable
                      disabled={data?.partyName?.value === '' || totNetAmt == 0 ? true : false}
                      value={tcsSections?.find((item) => item.section == data.tcsOptions) || null}
                      // onChange={handleTcsOptionChange}
                      onChange={(event, newValue, reason) => {
                        handleTcsOptionChange(event, newValue);

                        if (reason === 'clear') {
                          handleTcsOptionChange(event, null);
                        }
                      }}
                      options={['Add New TCS Option', ...tcsSections]}
                      getOptionLabel={(option) => option.option}
                      fullWidth
                      PopperComponent={(props) => {
                        const tableCell = props.anchorEl?.closest('td');
                        const totalWidth = tableCell ? tableCell.offsetWidth : 'auto';

                        return (
                          <Popper
                            {...props}
                            style={{
                              ...props.style,
                              width: totalWidth,
                            }}
                            placement="bottom-start"
                          />
                        );
                      }}
                      renderOption={(props, option) => (
                        <>
                          {option === 'Add New TCS Option' ? (
                            <MenuItem
                              value={'addTcsOption'}
                              onClick={handleAddNewTcsOptionClick}
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                position: 'sticky',
                                // bottom: "-7.5px",
                                top: '0px',
                                zIndex: 1,
                                backgroundColor: grey[50],
                                '&:hover': {
                                  backgroundColor: grey[200],
                                },
                              }}
                            >
                              <AddBox
                                fontSize="small"
                                sx={{
                                  marginRight: '5px',
                                  color: 'primary.main',
                                }}
                              />
                              <ListItemText sx={{ color: 'primary.main' }} primary="Add New TCS Option" />
                            </MenuItem>
                          ) : (
                            <li {...props}>{option.option}</li>
                          )}
                        </>
                      )}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          name="tcsOptions"
                          label={labelNamesOfTcs?.tcsOrTdsLabel}
                          variant="outlined"
                          size="small"
                          sx={{
                            '.css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root': {
                              fontSize: '14px',
                            },
                            label: {
                              fontSize: '14px',
                            },
                            '.css-lnk63-MuiButtonBase-root-MuiMenuItem-root': {
                              fontSize: '14px',
                            },
                            '.css-1atz3nw-MuiFormLabel-root-MuiInputLabel-root': {
                              color: 'input.font',
                            },
                            '.css-1d3z3hw-MuiOutlinedInput-notchedOutline': {
                              borderColor: 'input.border',
                            },
                            '.css-1jiigs4-MuiFormLabel-root-MuiInputLabel-root': {
                              color: 'input.font',
                            },
                            '.css-14qz1ij-MuiListItemText-root': {
                              margin: '0px',
                            },
                            '.css-wgai2y-MuiFormLabel-asterisk': {
                              color: 'danger.main',
                            },
                          }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      )}
                    />
                  </Box>
                  <Box sx={{ width: '100%', flex: 2 }}>
                    <MoneyTextField
                      error={data.errorStatus.tcsPercent == true ? true : false}
                      value={data.tcsPercent?Number(data.tcsPercent):null}
                      disabled={data?.partyName?.value === '' || totNetAmt == 0 ? true : false}
                      required={data.tcsFlag === 1 ? true : false}
                      onChange={(val)=>handleTcsPercentChange(val)}
                      // onBlur={handleTcsPercentBlur}
                      id="tcsPercent"
                      label={labelNamesOfTcs?.tcsOrTdsAmountLabel}
                      variant="outlined"
                      size="small"
                      min={0}
                      max={99.99}
                      fullWidth
                      sx={{
                        flex: 1,
                        '.css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root': {
                          fontSize: '14px',
                        },
                        label: {
                          fontSize: '14px',
                        },
                        '.css-1atz3nw-MuiFormLabel-root-MuiInputLabel-root': {
                          color: 'input.font',
                        },
                        '.css-1d3z3hw-MuiOutlinedInput-notchedOutline': {
                          borderColor: 'input.border',
                        },
                        '.css-wgai2y-MuiFormLabel-asterisk': {
                          color: 'danger.main',
                        },
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <PercentIcon fontSize="14px" />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Box>
                </>
              </TableCell>

              <TableCell align="right" sx={{ minWidth: '120px', fontWeight: 400, fontSize: '14px' }}>
                <MoneyTextField
                  error={data.errorStatus.tcsAmount == true ? true : false}
                  label="TCS Amount"
                  id="tcsAmount"
                  name="tcsAmount"
                  size="small"
                  state={data}
                  currencyType={data.currency.sign}
                  disabled={data?.partyName?.value === '' || totNetAmt == 0 ? true : false}
                  value={(data.tcsAmount)?Number(data?.tcsAmount):null}
                  onChange={(val)=>handleTcsAmountChange(val)}
                  // onBlur={handleTcsAmountBlur}
                  min={0}
                  max={Number(totTaxAmt)-1}
                  maxErrorMessage='The entered TCS amount must not exceed the total Taxable Amount. Please correct the value.'
                  type="text"
                  fullWidth
                  sx={{
                    flex: 1,
                    width: 140,
                  }}
                  InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            {data?.currency?.sign}
                          </InputAdornment>
                        ),
                            inputProps: {
      style: { textAlign: 'right' } 
    }

                      }}
                />
                {/* {data?.currency?.sign}{" "}
                {MoneyFormatv3(Number(data.tcsAmount).toFixed(2), "en-IN")} */}
              </TableCell>
            </TableRow>
            <TableRow sx={{ fontWeight: 400, fontSize: '14px', height: '30px' }}>
              <TableCell sx={{ fontWeight: 400, fontSize: '14px' }}>{labelNamesOfTcs?.amountAfterLabel}</TableCell>
              <TableCell></TableCell>
              <TableCell align="right" sx={{ fontWeight: 400, fontSize: '14px' }}>
                {data?.currency?.sign} {MoneyFormatv3(Number(amountAfterTCS).toFixed(2), 'en-IN')}
              </TableCell>
            </TableRow>

            <TableRow sx={{ fontWeight: 400, fontSize: '14px', height: '30px' }}>
              <TableCell sx={{ fontWeight: 400, fontSize: '14px', minWidth: '120px' }}>Round Off</TableCell>
              <TableCell align="left">
                <MoneyTextField
                  size="small"
                  type="text"
                  name="roundOff"
                  id="roundOff"
                  label="Round off (+/-)"
                  value={data.roundOff?Number(data?.roundOff):null}
                  disabled={data?.partyName?.value === '' || totNetAmt === 0}
                  // onFocus={(e) => {
                  //   setData((prev) => ({
                  //     ...prev,
                  //     roundOff: '',
                  //   }));
                  // }}
                  min={-99.99}
                  minErrorMessage='Round-off amount is below the minimum limit'
                  max={99.99}
                  maxErrorMessage='Round-off amount exceeds the maximum limit'
                  onChange={(val)=>handleRoundOffChange(val)}
                  // onBlur={handleRoundOffBlur}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  
                  InputProps={{
                    startAdornment: (
                          <InputAdornment position="start">
                            {data?.currency?.sign}
                          </InputAdornment>
                        ),
                    inputProps: {
                      style: {
                        textAlign: 'right',
                      },
                    },
                  }}
                />
              </TableCell>
              {/* <TableCell align="right">
                {data?.currency?.sign}{' '}
                {isNaN(data.roundOff) ? MoneyFormatv3(Number(0)) : MoneyFormatv3(Number(data.roundOff).toFixed(2), 'en-IN')}
              </TableCell> */}
              <TableCell align="right">
                {isNaN(Number(data.roundOff))
                  ? `${data?.currency?.sign} ${MoneyFormatv3(0)}`
                  : Number(data.roundOff) < 0
                  ? `(${data?.currency?.sign} ${MoneyFormatv3(Number(data.roundOff).toFixed(2), 'en-IN')})`
                  : `${data?.currency?.sign} ${MoneyFormatv3(Number(data.roundOff).toFixed(2), 'en-IN')}`}
              </TableCell>
            </TableRow>
            <TableRow sx={{ fontWeight: 400, fontSize: '14px', height: '30px' }}>
              <TableCell sx={{ fontWeight: 'bold', fontSize: '14px' }}>Net Amount</TableCell>
              <TableCell></TableCell>
              <TableCell align="right" sx={{ minWidth: '120px', fontWeight: 'bold', fontSize: '14px' }}>
                {data?.currency?.sign} {MoneyFormatv3(Number(netAmountToPay), 'en-IN')}
              </TableCell>
            </TableRow>

            <TableCell></TableCell>
            {((ewaybillflag || einvoiceflag) &&
              (registrationtype == 2 || registrationtype == 4) &&
              location.pathname === '/addnewinvoicetax') ||
            (ewaybillflag && location.pathname === '/addnewpurchasetax' && data?.partyCategory !== 'UB') ? (
              <TableRow>
                <TableCell sx={{ minWidth: { xs: 150, sm: 200 } }}>
                  {ewaybillflag && hasGoods ? (
                    <Box display="flex" alignItems="center">
                      <Checkbox
                        size="medium"
                        sx={{
                          padding: '0px',
                        }}
                        id="copy-address-eway"
                        name="copy-address-eway"
                        onChange={() => setEwayImp(!eWayImp)}
                        checked={eWayImp ? true : false}
                      />
                      <FormLabel
                        htmlFor="copy-address-eway"
                        sx={{
                          fontSize: { xs: '11px', sm: '13px' },
                          color: 'red',
                          fontWeight: 'bold',
                          letterSpacing: 0,
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          marginLeft: '5px',
                        }}
                      >
                        Generate E-way Bill Now
                      </FormLabel>
                    </Box>
                  ) : (
                    ''
                  )}
                </TableCell>

                <TableCell sx={{ minWidth: { xs: 150, sm: 180 } }}>
                  {einvoiceflag &&
                  (registrationtype == 2 || registrationtype == 4) &&
                  data.partyName.gstCategory &&
                  data.partyName.gstCategory !== 'UB' &&
                  location.pathname === '/addnewinvoicetax' ? (
                    <Box display="flex" alignItems="center">
                      <Checkbox
                        size="medium"
                        sx={{
                          padding: '0px',
                        }}
                        id="copy-address-einv"
                        name="copy-address-einv"
                        onChange={() => setEImp(!eImp)}
                        checked={eImp ? true : false}
                      />
                      <FormLabel
                        htmlFor="copy-address-einv"
                        sx={{
                          fontSize: { xs: '11px', sm: '13px' },
                          color: 'red',
                          fontWeight: 'bold',
                          letterSpacing: 0,
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          marginLeft: '5px',
                        }}
                      >
                        Generate E-invoice Now
                      </FormLabel>
                    </Box>
                  ) : (
                    ''
                  )}
                </TableCell>
                {einvoiceflag &&
                data.partyName.gstCategory &&
                data.partyName.gstCategory !== 'UB' &&
                location.pathname === '/addnewinvoicetax' ? (
                  <TableCell sx={{ minWidth: { xs: 200, sm: 280 } }}>
                    <b>Note:</b> Don't tick if need to generate later
                  </TableCell>
                ) : ewaybillflag && items && items?.length > 0 && items[0]?.name?.label !== '' ? (
                  <TableCell sx={{ minWidth: { xs: 200, sm: 280 } }}>
                    <b>Note:</b> Don't tick if need to generate later
                  </TableCell>
                ) : (
                  ''
                )}
              </TableRow>
            ) : null}
          </TableBody>
          {/* {invoiceEntry?.length !== 0 && (
            <TableRow>
              <TableCell sx={{ display: 'flex' }}>
                <Typography
                  id="editN"
                  underline="hover"
                  sx={{
                    pointerEvents: 'auto !important',
                    cursor: 'pointer !important',
                    color: '#1D79FF !important',
                    display: 'flex',
                    alignItems: 'center',
                    textDecoration: 'underline',
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    setOpenTransaction(true);
                  }}
                >
                  <Typography
                    sx={{
                      pointerEvents: 'auto !important',
                      cursor: 'pointer !important',
                      color: '#1D79FF !important',
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >
                    {Type === 'Purchase' ? 'View Payments' : Type === 'Sales' ? 'View Receipts' : ''}
                  </Typography>
                </Typography>
              </TableCell>
            </TableRow>
          )} */}
        </Table>
      </TableContainer>
      {/* {Type === "Sales" && openLinkToReceiptModal === true && (
        <LinkToReciept
          open={openLinkToReceiptModal}
          setOpen={setOpenLinkToReceiptModal}
          accountID={partyAccountID}
          setTransArr={setLinkedTransArr}
          entryData={invoiceEntry}
          showWarningSnackbar={showWarningSnackbar}
          invoiceDetails={data}
          setCurrentLinkedAmt={setCurrentLinkedAmt}
          invoiceAmount={netAmountToPay}
        />
      )} */}
      {/* {Type === "Purchase" && openLinkToReceiptModal === true && (
        <LinktoPayment
          open={openLinkToReceiptModal}
          setOpen={setOpenLinkToReceiptModal}
          accountID={partyAccountID}
          setTransArr={setLinkedTransArr}
          entryData={invoiceEntry}
          showWarningSnackbar={showWarningSnackbar}
          invoiceDetails={data}
          setCurrentLinkedAmt={setCurrentLinkedAmt}
          invoiceAmount={netAmountToPay}
        />
      )} */}
      {openTdsTcsModal === true && (
        <AddTdsTcsOptions
          open={openTdsTcsModal}
          setOpen={setOpenTdsTcsModal}
          optionType={optionType}
          setOptionType={setOptionType}
          setData={setData}
          data={data}
          Type="Invoice"
          totTaxAmt={totTaxAmt}
        />
      )}
      {invoiceEntry?.length !== 0 && (
        <ViewTransactionDetails open={openTransaction} setOpen={setOpenTransaction} accountID={partyAccountID} Type={Type} data={data} />
      )}
    </Box>
  );
}

export default TotalAmountLabels;
